import { IApiRequestConfig } from '../api.types';
import {
  IUpdateUserEmailData,
  IUpdateUserProfileData,
  IUser,
  IUserCreate,
  IUserSearchParams,
  IUserSignUpForm,
  IUserUpdate,
} from '../../resource/user/user.types';

export const searchUserApi = (params?: IUserSearchParams): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'searchUsers',
  uri: 'json',
  action: 'getUsers',
  method: 'get',
  params: {
    ...params,
  },
});

export const createUserApi = (user: IUserCreate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createUser',
  uri: 'json',
  action: `users`,
  method: 'post',
  data: user,
  v2: true,
});

export const updateUserApi = (user: IUserUpdate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateUser',
  uri: 'json',
  action: `users/${user.id}`,
  method: 'patch',
  data: user,
  v2: true,
});

export const checkUserExistenceApi = (email: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'checkUserExistence',
  uri: 'json',
  action: `users/exists`,
  method: 'get',
  params: { email },
  v2: true,
});

export const updateUserEmailApi = (data: IUpdateUserEmailData): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateUserEmail',
  uri: 'json',
  action: `self/update-email`,
  method: 'patch',
  data,
  v2: true,
});

export const deleteUserApi = (userId: IUser['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteUser',
  uri: 'json',
  action: `users/${userId}`,
  method: 'delete',
  v2: true,
});

export const enableUserApi = (userId: IUser['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'enableUser',
  uri: 'json',
  action: `users/${userId}/restore`,
  method: 'patch',
  v2: true,
});

export const updateUserProfileApi = (data: IUpdateUserProfileData): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'self',
  uri: 'json',
  action: 'self',
  method: 'patch',
  data: data,
  v2: true,
});

export function signUpUserApi(data: IUserSignUpForm): IApiRequestConfig<unknown, unknown> {
  throw new Error('Function not implemented.');
}
